// src/components/marketing/demoData.js
// Zentrale Daten für alle Demo-Darstellungen (Filmstreifen, andere Theme-Branches).
//
// THEME_SCREENSHOTS: Full-Page-Screenshots (hoch!) — für den Desktop-Hover-Effekt,
//   bei dem die Seite im Frame durchscrollt.
// THEME_HEROES: 4:3-Hero-Ausschnitte — für Mobile, wo es kein Hover gibt und das
//   statische Bild allein verkaufen muss. Sobald ein Hero-Bild eingetragen ist,
//   wird es mobil genutzt; fehlt es, wird automatisch ein Crop aus dem
//   Full-Page-Screenshot erzeugt (Fallback).

export const ALL_DEMOS = [
  { id: 'classic', name: 'Classic', url: 'https://siwedding.de/demo-classic' },
  { id: 'botanical', name: 'Botanical', url: 'https://siwedding.de/demo-botanical' },
  { id: 'contemporary', name: 'Contemporary', url: 'https://siwedding.de/demo-contemporary' },
  { id: 'editorial', name: 'Editorial', url: 'https://siwedding.de/demo-editorial' },
  { id: 'luxe', name: 'Luxe', url: 'https://siwedding.de/demo-luxe' },
  { id: 'modern', name: 'Modern', url: 'https://siwedding.de/demo-parallax' },
  { id: 'neon', name: 'Neon', url: 'https://siwedding.de/demo-neon' },
  { id: 'video', name: 'Video', url: 'https://siwedding.de/demo-video' },
];

// Stil-Beschreibungen für die Theme-Auswahl auf der Homepage.
// Bewusst als Hochzeitsstil formuliert, nicht als Theme-Feature:
// "Welcher Stil passt zu eurer Hochzeit?" statt "Welches Template?"
export const STYLE_WORDS = {
  classic: ['Zeitlos', 'Elegant', 'Klassisch'],
  botanical: ['Natürlich', 'Romantisch', 'Organisch'],
  contemporary: ['Modern', 'Kreativ', 'Urban'],
  editorial: ['Fashion', 'Minimal', 'Redaktionell'],
  luxe: ['Luxuriös', 'Ruhig', 'Golden'],
  modern: ['Reduziert', 'Klar', 'Bewegt'],
  neon: ['Mutig', 'Digital', 'Laut'],
  video: ['Cinematisch', 'Filmisch', 'Atmosphärisch'],
};

export const TAGLINES = {
  classic: 'Zeitlos in Schwarz-Weiß',
  botanical: 'Grün, organisch, glasklar',
  contemporary: 'Verspielt & farbstark',
  editorial: 'Magazin-Look mit Statement',
  luxe: 'Gold, Ruhe, Eleganz',
  modern: 'Minimalistisch mit Parallax',
  neon: 'Mutig, digital, laut',
  video: 'Cinematisch mit Bewegtbild',
};

// Full-page screenshots hosted on Cloudinary
// Naming: {theme}_demoShowcase_{cloudinarySlug}.jpg
export const THEME_SCREENSHOTS = {
  editorial: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1784712397/Editorial_full_rs21tn.jpg',
  botanical: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1770727740/botanical_demoShowcase_optimized_cd6i9j.jpg',
  contemporary: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1770297629/coontemporary_demoShowcase_wiicti.jpg',
  luxe: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1784712397/Luxe_full_saacqv.jpg',
  neon: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1784712397/Neon_full_uwsn2f.jpg',
  video: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1770727740/video_demoShowcase_optimized_jrlsoh.jpg',
  classic: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_1200/v1771224839/Bildschirmfoto_16-2-2026_75342_www.siwedding.de_gbf6ps.jpg',
};

// 4:3-Hero-Bilder für Mobile (vollständig seit Jul 2026).
// Format: Screenshot des jeweiligen Demo-Heros, ausgeliefert mit q_auto,f_auto,w_800.
export const THEME_HEROES = {
  classic: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713089/classic_mobile_jq0bhr.png',
  botanical: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713088/botanical_mobile_tyjoee.png',
  contemporary: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713088/contemporary_mobile_fnaa4n.png',
  editorial: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713088/editorial_mobile_m78tat.png',
  luxe: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713088/luxe_mobile_a5ltpq.png',
  modern: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713087/modern_mobile_bfzthy.png',
  neon: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713087/neon_mobile_aylnsv.png',
  video: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_800/v1784713087/video_mobile_tpvlju.png',
};

// Mobile-Screenshots (Hochkant, ~9:19) für die Handy-Frames im mobilen
// Filmstrip. Aufnahme: DevTools Device-Toolbar (iPhone-Viewport 390px),
// dann Screenshot. Ausgeliefert mit q_auto,f_auto,w_450.
// Vollständig seit Jul 2026 (Lea-&-Ben-Demos).
export const THEME_MOBILE_SCREENS = {
  classic: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491709/Mobile_Classic_jesu3r.png',
  botanical: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491712/Mobile_Botanical_jhoqzg.png',
  contemporary: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491711/Mobile_Contemporary_jkhnyk.png',
  editorial: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491712/Mobile_Editorial_spraky.png',
  luxe: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491713/Mobile_Luxe_j1xido.png',
  modern: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491711/Mobile_Parallax_ncz0f5.png',
  neon: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491713/Mobile_Neon_smqqdn.png',
  video: 'https://res.cloudinary.com/si-weddings/image/upload/q_auto,f_auto,w_450/v1785491712/Mobile_Video_nyofhe.png',
};

// Hochkant-Fallback aus dem Full-Page-Screenshot für den Handy-Frame
export const phoneFallbackUrl = (url, horizontal = false) =>
  url ? url.replace('/upload/q_auto,f_auto,w_1200/', `/upload/q_auto,f_auto,c_fill,${horizontal ? 'g_west' : 'g_north'},w_450,h_950/`) : undefined;

// Bestes verfügbares Bild für den mobilen Handy-Frame:
// 1. dedizierter Phone-Screenshot, 2. Mobile-Hero (die gelieferten *_mobile-Bilder
// sind Hochkant-Screenshots und füllen die 9:19-Frames sauber), 3. Crop-Fallback
export const phoneCardUrl = (id) =>
  THEME_MOBILE_SCREENS[id]
  || THEME_HEROES[id]
  || phoneFallbackUrl(THEME_SCREENSHOTS[id], HORIZONTAL_THEMES.includes(id));

// Loopende Bildschirmaufnahmen der Demos für die Desktop-Previews.
// Seit Jul 2026 für alle Themes vorhanden (Lea-&-Ben-Demos) — Desktop zeigt
// das Video statt des Screenshot-Scroll-Effekts. MP4 von Cloudinary,
// URL-Muster: .../video/upload/q_auto/vXXXX/datei.mp4
export const THEME_VIDEO_PREVIEWS = {
  classic: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491747/Demo_Classic_yacvxb.mp4',
  botanical: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491730/Demo_Botanical_gnot6c.mp4',
  contemporary: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491741/Demo_Contemporary_wezjqs.mp4',
  editorial: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491767/Demo_Editorial_dwuuxe.mp4',
  luxe: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491741/Demo_Luxe_agamqa.mp4',
  modern: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491728/Demo_Parallax_e9cn0y.mp4',
  neon: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491749/Demo_Neon_r2khn8.mp4',
  video: 'https://res.cloudinary.com/si-weddings/video/upload/q_auto/v1785491733/Demo_Video_fongni.mp4',
};

// Themes, deren Demo horizontal scrollt — die Desktop-Preview scrollt dann
// von links nach rechts statt von oben nach unten. Der Full-Page-Screenshot
// muss dafür QUER sein (ein hoher, breiter Streifen der ganzen Seite).
// Poster aus dem Video selbst: Cloudinary schneidet mit so_<sekunde> einen
// Frame heraus und liefert ihn als Bild aus.
//
// Warum nicht THEME_SCREENSHOTS als Poster: Die Videos zeigen durchgehend die
// aktuellen Lea-&-Ben-Demos (Jul 2026), die Desktop-Screenshots stammen aus
// drei älteren Aufnahmen — teils noch Feb 2026. Als Standbild vor dem Video
// gäbe das einen sichtbaren Bruch beim Hover.
// second = 0: der erste Frame zeigt den Hero der jeweiligen Demo — genau das,
// was in den Vorschaufenstern zu sehen sein soll.
export const videoPosterUrl = (id, second = 0) => {
  const url = THEME_VIDEO_PREVIEWS[id];
  if (!url) return undefined;
  return url
    .replace('/video/upload/q_auto/', `/video/upload/q_auto,so_${second}/`)
    .replace(/\.mp4$/, '.jpg');
};

export const HORIZONTAL_THEMES = ['video'];

// Thumbnail-Crop vom oberen Seitenbereich (für Grids/Karten)
export const thumbUrl = (url) =>
  url ? url.replace('/upload/q_auto,f_auto,w_1200/', '/upload/q_auto,f_auto,c_fill,g_north,w_600,h_450/') : undefined;

// 4:3-Hero-Fallback aus dem Full-Page-Screenshot, solange kein echtes Hero-Bild existiert.
// Vertikale Seiten: Crop von oben (g_north); horizontale Seiten: Crop von links (g_west).
export const heroFallbackUrl = (url, horizontal = false) =>
  url ? url.replace('/upload/q_auto,f_auto,w_1200/', `/upload/q_auto,f_auto,c_fill,${horizontal ? 'g_west' : 'g_north'},w_800,h_600/`) : undefined;

// Bestes verfügbares Mobile-Bild für eine Demo
export const mobileCardUrl = (id) =>
  THEME_HEROES[id] || heroFallbackUrl(THEME_SCREENSHOTS[id], HORIZONTAL_THEMES.includes(id));

// Demo-URL inklusive Herkunft.
// Bewusst KEINE utm_*-Parameter: sarahiver.com und siwedding.de sind in GA4
// als Cross-Domain verknüpft — ein utm_source auf dem Zielaufruf würde dort
// eine neue Sitzung/Attribution erzwingen und den Funnel zerschneiden.
// ?src / ?article sind neutral, landen aber in page_location und sind damit
// in GA4 (Landingpage) und in Server-Logs auswertbar.
// Demo-Links öffnen mit rel="noopener" (ohne "noreferrer"): Der Referrer
// (wegen Referrer-Policy nur die Origin "https://sarahiver.com/") ist nötig,
// damit der Report Demo-Besuche der Website zuordnen kann. Mit "noreferrer"
// kam auf siwedding.de kein Referrer an → "Demo besucht: 0".
export const demoUrl = (id, { placement, article } = {}) => {
  const base = ALL_DEMOS.find(d => d.id === id)?.url || ALL_DEMOS[0].url;
  const params = new URLSearchParams();
  if (placement) params.set('src', placement);
  if (article) params.set('article', article);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
};

// Link von einer Demo/Theme-Karte zum Anfrageformular, inklusive Stil.
// Der Stil landet als Hash-Parameter in der URL (teilbar, im Verlauf sichtbar)
// UND über setStyleChoice in der Session — so überlebt er auch den Umweg
// über die Demo auf siwedding.de.
export const inquiryUrl = (themeId) =>
  themeId ? `/#contact?theme=${encodeURIComponent(themeId)}` : '/#contact';

const STYLE_KEY = 'si_style_choice';

export const setStyleChoice = (themeId, placement) => {
  if (typeof window === 'undefined' || !themeId) return;
  try {
    sessionStorage.setItem(STYLE_KEY, JSON.stringify({
      theme: themeId, placement: placement || 'unknown', ts: Date.now(),
    }));
  } catch { /* sessionStorage nicht verfügbar */ }
};

export const getStyleChoice = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STYLE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

// "Diesen Stil anfragen" — ein Aufruf für Tracking, Session und Navigation
export const trackStyleInquiry = (themeId, placement) => {
  setStyleChoice(themeId, placement);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'inquiry_click', {
      event_category: 'conversion',
      event_label: themeId,
      theme: themeId,
      cta_placement: placement || 'unknown',
      source_page: window.location.pathname,
    });
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('selectTheme', { detail: themeId }));
  }
};

// ACHTUNG: Parameter NICHT 'source' nennen — GA4 liest 'source'/'medium'/
// 'campaign' auf jedem Event als manuelle Sitzungsquelle. Das war die Ursache
// für die Quellen "filmstrip / (not set)" und "filmstrip_mobile / (not set)"
// im Report; diese Sitzungen fehlten entsprechend bei google/organic.
export const trackDemoClick = (label, url, placement, article) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'demo_click', {
      event_category: 'engagement',
      event_label: label,
      demo_url: url,
      demo: label,
      cta_placement: placement,
      source_page: typeof window !== 'undefined' ? window.location.pathname : '',
      article: article || 'none',
      engagement_time_msec: 100,
    });
  }
};
